export class ToolDatamatrix {
    toolId = 0;
    toolUID = '';
    engravedCode = '';
    toolName = '';
    isEngraved = false;

    constructor(toolDM) {
        this.toolId = toolDM.id;
        this.toolUID = toolDM.uid;
        this.engravedCode = toolDM.engravedCode;
        this.toolName = toolDM.name;
        this.isEngraved = toolDM.isEngraved;
    }
}
